// REQ-400 freehand highlight tool (#1324) — the values that differ from the figure tool's. The
// PALETTE itself is deliberately NOT redefined here: the issue asks for "the same multi-color
// palette as #1323", so the tool-options row imports HIGHLIGHT_PALETTE from
// figureHighlight.constants and only the defaults below are freehand-specific.
//
// The opacity bounds are shared too (MIN/MAX_HIGHLIGHT_OPACITY) — both endpoints declare the same
// 0-100 range.

import { HIGHLIGHT_PALETTE } from "./figureHighlight.constants"

/**
 * Starting color: pure yellow. Sampled from the design (nodes 18916:553416 / :553441) — both the
 * toolbar swatch and the drawn stroke render as `#FFFEAE`, i.e. R=G=255 with only blue reduced,
 * which is `#FFFF00` laid over white at the tool's opacity. Already in the shared palette, so this
 * introduces no new color. (The figure tool starts on red; a highlighter starting on yellow is the
 * design's own call, not an inconsistency.)
 */
export const DEFAULT_FREEHAND_HIGHLIGHT_COLOR: string = HIGHLIGHT_PALETTE[2]

// Starting opacity (%), matching the "44%" the armed tool-options row shows in the design and the
// figure tool's own default.
export const DEFAULT_FREEHAND_HIGHLIGHT_OPACITY = 44

/**
 * Starting stroke width, in pt.
 *
 * The design's armed row reads **24 pt**, which this deliberately does NOT use: the freehand create
 * endpoint declares `stroke_width` as `minimum: 1, maximum: 20` (verified via `pnpm run api:show`),
 * so 24 would be rejected outright. 20 is the largest legal value, which keeps the issue's "thick
 * enough to read as 'highlighter,' not a thin pen line" intact. If 24 really is the intent, the
 * endpoint's maximum has to move first — see the PR description.
 */
export const DEFAULT_FREEHAND_HIGHLIGHT_STROKE_WIDTH = 20
export const MIN_FREEHAND_HIGHLIGHT_STROKE_WIDTH = 1
export const MAX_FREEHAND_HIGHLIGHT_STROKE_WIDTH = 20
